import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  modalContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: "none",
    borderRadius: "8px",
    maxHeight: "90vh", // Limits height to 90% of viewport
    width: "90%", // Takes 90% of screen width
    maxWidth: "800px", // But never wider than 800px
    overflowY: "auto", // Only vertical scrolling
    display: "flex",
    flexDirection: "column",

    // Responsive adjustments
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      padding: theme.spacing(2),
      maxHeight: "95vh",
    },
  },
}));

export default useStyles;
